import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  Router,
} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideStore} from '@ngrx/store';
import {provideEffects} from '@ngrx/effects';
import {
  provideHttpClient,
  withInterceptors,
  withXhr
} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import {TranslateModule} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import {TraceService} from '@sentry/angular';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {provideMatomo} from 'ngx-matomo-client';
import {APP_ROUTES} from './app.routes';
import {store} from './store/store';
import * as authEffects from './store/auth/effects/auth.effects';
import * as contactEffects from './store/contact/effects/contact.effects';
import * as portalEffects from './store/portal/effects/portal.effects';
import * as sharedLinkEffects from './store/shared-link/effects/shared-link.effects';
import {DEFAULT_LANG_KEY} from './functions/translate-utils';
import {isMatomoConfigured} from './functions/matomo';
import {AlertCardComponent} from './components/alert-card/alert-card.component';
import {guestTokenInterceptor} from './interceptors/guest-token.interceptor';
import {
  MATOMO_CONFIG,
  MatomoService,
} from './services/matomo/matomo.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(APP_ROUTES),
    provideHttpClient(withXhr(), withInterceptors([guestTokenInterceptor])),
    provideAnimations(),
    provideStore(store),
    provideEffects([authEffects, contactEffects, portalEffects, sharedLinkEffects]),
    provideEnvironmentNgxMask(),
    importProvidersFrom(
      ToastrModule.forRoot({toastComponent: AlertCardComponent}),
      TranslateModule.forRoot({
        defaultLanguage: DEFAULT_LANG_KEY,
        loader: provideTranslateHttpLoader({
          prefix: './assets/i18n/',
          suffix: '.json',
        }),
      }),
    ),
    // Sentry config
    {provide: ErrorHandler, useValue: Sentry.createErrorHandler()},
    {provide: Sentry.TraceService, deps: [Router]},
    provideAppInitializer(() => { inject(TraceService); }),
    provideMatomo(() => ({
      mode: 'deferred',
      disabled: !isMatomoConfigured(inject(MATOMO_CONFIG)),
      enableLinkTracking: false,
      trackAppInitialLoad: false,
    })),
    provideAppInitializer(() => inject(MatomoService).startPageViewTracking()),
  ],
};
